import { Skeleton } from '@/components/ui/skeleton';
import KpiCardSkeleton from '@/components/common/KpiCardSkeleton';

export default function PageSkeleton() {
  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {/* Sidebar — hidden on mobile */}
      <aside className="hidden md:flex w-60 flex-col flex-shrink-0 bg-sidebar">
        <div className="h-16 border-b border-white/10 px-4 flex items-center">
          <Skeleton className="h-7 w-28 bg-white/20" />
        </div>
        <div className="flex-1 py-3 px-2 space-y-1">
          {Array.from({ length: 8 }).map((_, i) => (
            <Skeleton key={i} className="h-9 w-full rounded-md bg-white/10" />
          ))}
        </div>
        <div className="border-t border-white/10 p-4">
          <Skeleton className="h-8 w-full rounded-md bg-white/10" />
        </div>
      </aside>

      <div className="flex flex-1 flex-col overflow-hidden">
        {/* TopNav */}
        <header className="flex h-16 shrink-0 items-center justify-between border-b bg-white px-4">
          <Skeleton className="h-5 w-32" />
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-8 w-8 rounded-full" />
          </div>
        </header>

        <main className="flex-1 overflow-y-auto p-4 md:p-6 space-y-6">
          <Skeleton className="h-7 w-48" />

          {/* 4 KPI cards */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <KpiCardSkeleton key={i} />
            ))}
          </div>

          {/* Table stub */}
          <div className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
            <div className="p-4 border-b">
              <Skeleton className="h-9 w-56" />
            </div>
            <div className="bg-gray-50 border-b px-4 py-3 flex gap-8">
              {[100, 80, 120, 60, 80].map((w, i) => (
                <Skeleton key={i} className="h-3" style={{ width: w }} />
              ))}
            </div>
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="flex gap-8 px-4 py-3 border-b last:border-b-0">
                {[100, 80, 120, 60, 80].map((w, j) => (
                  <Skeleton key={j} className="h-4" style={{ width: w }} />
                ))}
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}
